/**
 * One labelled screenshot (or a placeholder when there is none), shared by the
 * Visual page's viewer and the proof page's checkpoint block.
 *
 * @module features/visual/VisualPane
 */
import React from 'react';
import { Text } from '@chatsdet/ui';

export const IMG_CLASS =
  'block w-full h-auto outline outline-1 -outline-offset-1 outline-black/10 dark:outline-white/10';

export function Pane({ title, url, missing }: { title: string; url: string | null; missing: string }) {
  return (
    <figure className="min-w-0 space-y-2">
      <figcaption>
        <Text size="sm" className="font-medium">
          {title}
        </Text>
      </figcaption>
      {url ? (
        <img src={url} alt={`${title} screenshot`} className={IMG_CLASS} />
      ) : (
        <div className="flex aspect-video items-center justify-center rounded-lg bg-muted/40 text-center">
          <Text size="sm" className="text-muted-foreground">
            {missing}
          </Text>
        </div>
      )}
    </figure>
  );
}
